import axios from 'axios'
import { MessageBox, Message } from 'element-ui'

const api = axios.create({
    baseURL: process.env.VUE_APP_API_ROOT,
    timeout: 20000,
    responseType: 'json'
    // withCredentials: true
})

// 请求前拦截
api.interceptors.request.use(
    request => {
        return request
    }
)
let isAlertRelogin = false
api.interceptors.response.use(
    response => {
        const code = response.data.code
        if (code !== 1) {
            MessageBox.alert(response.data.msg, '提示', {
                type: 'error'
            })
            return Promise.reject(response.data)
        } else {
            return Promise.resolve(response.data)
        }
    },
    error => {
        Message.error('接口异常')
        return Promise.reject(error)
    }
)

export default api
